import { isNotBlank } from '~/composable/util';
import type { AppCodeMap, AppValueOption } from '@/types/type';
import axios from "axios";
import * as _ from "lodash";

const baseUrl = "/api/base";

// 비밀번호 찾기 - 이메일 발송
const sendEmailApi = async (data: any): Promise<void> => {
  const { $axios } = useNuxtApp();
  return $axios.post(`${baseUrl}/sendEmail`, data);
}

const changePasswordByEmailApi = async (data: any): Promise<void> => {
  const { $axios } = useNuxtApp();
  return $axios.post(`${baseUrl}/change-password/email`, data);
}

const confirmPasswordChangeHashApi = async (encryptHashMap: any): Promise<void> => {
  const { $axios } = useNuxtApp();
  return $axios.post(`${baseUrl}/confirm/password/change/hash`, encryptHashMap);
}

// 세션정보 획득
const authorizationApi = async (): Promise<void> => {
  const config = useRuntimeConfig();
  if ( config.public.skipInitialize === 'true' ) {
    return;
  }
  const { $axios } = useNuxtApp();
  const store = useAuthStore();
  const { me, isInitializeCompleted } = storeToRefs(store);

  axios.defaults.baseURL = config.public.apiBase;
  axios.defaults.headers.common["Content-Type"] = "application/json";

  const response = await axios.post(`${baseUrl}/authorization`);
  me.value = _.get(response, ['data', 'body', 'appUser'], null);
  isInitializeCompleted.value = true;
}

/** 전체 코드맵 획득  */
const getCodeMap = async () => {
  const config = useRuntimeConfig();
  if ( config.public.skipInitialize === 'true' ) {
    return;
  }  
  await storeCodeMapRefresh();
  const store = useCodeMapStore();
  const { codeMap } = storeToRefs(store);
  return codeMap.value;
}

/** 코드로 코드맵 획득  */
const getCodeMapByCode = (code: string) => {
  storeCodeMapRefresh();
  const { getCodeMapByCode } = useCodeMapStore();
  return getCodeMapByCode(code);
}

/** label로 정렬한 options */
const getOptionsByCode = (code: string) => {
  storeCodeMapRefresh();
  const { getOptionsByCode } = useCodeMapStore();
  return getOptionsByCode(code, false);
}

/** value로 정렬한 options */
const getOptionsByCodeSortByValue = (code: string) => {
  storeCodeMapRefresh();
  const { getOptionsByCode } = useCodeMapStore();
  return getOptionsByCode(code, true);
}

const storeCodeMapRefresh = async () => {
  const config = useRuntimeConfig();
  axios.defaults.baseURL = config.public.apiBase;
  axios.defaults.headers.common["Content-Type"] = "application/json";
  const dayjs = useDayjs()

  const store = useCodeMapStore();
  const { codeMap, time } = storeToRefs(store);
  if(codeMap.value == null || Object.keys(codeMap.value).length === 0  || dayjs().diff(time.value, 'm') > 10) {
    const response = await axios.get(`${baseUrl}/code-map`, );
    codeMap.value = response.data.body;
    time.value = dayjs();
    return;
  }
}

// 비밀번호 변경
const changePasswordApi = async (data: any): Promise<void> => {
  const { $axios } = useNuxtApp();
  return await $axios.put(`${baseUrl}/change-password`, data);
}

// 멘토링 비밀번호 변경
const changeMentoringPasswordApi = async (data: any): Promise<void> => {
  const { $axios } = useNuxtApp();
  return await $axios.put(`${baseUrl}/change-mentoring-password`, data);
}

export {
  sendEmailApi, changePasswordByEmailApi, confirmPasswordChangeHashApi,
  authorizationApi,
  getCodeMap, 
  getCodeMapByCode, getOptionsByCode, getOptionsByCodeSortByValue,
  changePasswordApi, changeMentoringPasswordApi
};
